var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2{fill:none;stroke:#b53729;stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 85,
    cy: 85,
    r: 85
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.85,122.53a9.61,9.61,0,1,1-9.61-9.61A9.61,9.61,0,0,1,67.85,122.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.52,122.53a9.61,9.61,0,1,1-9.61-9.61A9.61,9.61,0,0,1,115.52,122.53Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 69.21,
    y1: 122.53,
    x2: 96.3,
    y2: 122.53
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "34.56 54.76 47.48 58.45 62.55 103.66 59.77 112.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.75,100.74a2.94,2.94,0,0,1-3.07,2.92H62.55L52.09,70.24h76.38Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 65.74,
    y1: 81.33,
    x2: 115.33,
    y2: 81.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 69.2,
    y1: 92.09,
    x2: 112.07,
    y2: 92.09
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.88fcdc2b809cd570ee7e4944cf975ee1.svg";
export { ForwardRef as ReactComponent };